import { PaymentIntentCoreBase } from "./payment-intent.core.base"


export class PaymentIntentCore extends PaymentIntentCoreBase {

}